import { render, staticRenderFns } from "./IndexArea.vue?vue&type=template&id=c7489bb8"
import script from "./IndexArea.vue?vue&type=script&lang=js"
export * from "./IndexArea.vue?vue&type=script&lang=js"
import style0 from "./IndexArea.vue?vue&type=style&index=0&id=c7489bb8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports